(() => {
    const cartDrawer = document.querySelector('#sidebar-cart');
    const pfandId = 7307181621397;

    // ip based cart/cheering bar
    const cartCheeringbar = cartDrawer.querySelector('.cart-drawer__cheeringbar');
    const cheeringbarFill = cartCheeringbar.querySelector('.cart-drawer__cheeringbar__fill');
    const remainingPriceEl = cartCheeringbar.querySelector('.cart-drawer__cheeringbar__hint b');

    // upsell
    // const cartUpsellSection = cartDrawer.querySelector('.cart-drawer__upsell');
    // const upsellSlider = cartDrawer.querySelector('.cart-drawer__upsell__slider');
    // const upsellCloses = cartDrawer.querySelectorAll('.cart-drawer__upsell__close');
    // const upsellAtcs = cartDrawer.querySelectorAll('.cart-drawer__upsell .ProductForm__AddToCart');

    window.updateCartDrawerHeight = () => {
        const cartDrawerTopHeight = cartDrawer.querySelector('.cart-drawer__top')?.clientHeight;
        document.documentElement.style.setProperty('--cartMiscHeight', cartDrawerTopHeight + 'px');
    }

    window.addEventListener('resize', updateCartDrawerHeight);

    // const openCartUpsellSection = () => {
    //     cartUpsellSection.style.height = cartUpsellSection.scrollHeight + 'px';
    //
    //     setTimeout(() => {
    //         updateCartDrawerHeight();
    //         cartUpsellSection.style.opacity = 1;
    //     }, 500);
    // };

    // const closeCartUpsellSection = () => {
    //     cartUpsellSection.style.opacity = 0;
    //
    //     setTimeout(() => {
    //         cartUpsellSection.style.height = 0;
    //         cartUpsellSection.style.marginTop = '0px';
    //     }, 200);
    //
    //     setTimeout(() => {
    //         updateCartDrawerHeight();
    //     }, 600);
    // };

    // const cartUpsellSwiper = new Swiper(upsellSlider, {
    //     spaceBetween: 10,
    //     pagination: {
    //         el: upsellSlider.querySelector('.swiper-pagination'),
    //         type: 'bullets',
    //         clickable: true
    //     },
    //     slidesPerView: 'auto'
    // });

    // const updateUpsellSwiperProducts = () => {
    //     const upsellProducts = cartDrawer.querySelectorAll('.cart-drawer__upsell__product');
    //     const cartItems = cartDrawer.querySelectorAll('.CartItemWrapper');
    //
    //     upsellProducts.forEach((upsellItem) => {
    //         cartItems.forEach((cartItem) => {
    //             if (upsellItem.dataset.variantId === cartItem.dataset.variantId) {
    //                 cartUpsellSwiper.removeSlide(upsellItem.dataset.index);
    //             }
    //         });
    //     });
    // };

    // if (sessionStorage.getItem('cartUpsellClosed') !== 'true') {
    //     openCartUpsellSection();
    // }

    const updateProductCheeringBar = (itemCount) => {
        const cartCheeringBarBowlsHint = cartDrawer.querySelector('.cart-drawer__cheeringbar__bowls');
        const cartCheeringBarBowlsHintPercentage = cartDrawer.querySelector('.cart-drawer__cheeringbar__bowls span');

        if (itemCount < 7) {
            cartCheeringBarBowlsHint.style.height = '0px';
            setTimeout(() => {
                window.updateCartDrawerHeight();
            }, 500);
        } else if (itemCount === 7) {
            cartCheeringBarBowlsHint.style.height = '46px';
            cartCheeringBarBowlsHintPercentage.textContent = '5%'
            setTimeout(() => {
                window.updateCartDrawerHeight();
            }, 500);
        } else if (itemCount > 7 && itemCount < 15) {
            cartCheeringBarBowlsHint.style.height = '46px';
            cartCheeringBarBowlsHintPercentage.textContent = '5%';
            setTimeout(() => {
                window.updateCartDrawerHeight();
            }, 500);
        } else if (itemCount >= 15) {
            cartCheeringBarBowlsHint.style.height = '46px';
            cartCheeringBarBowlsHintPercentage.textContent = '10%';
            setTimeout(() => {
                window.updateCartDrawerHeight();
            }, 500);
        } else {
            console.error("fatal error in bs-cart-drawer.js: unexpected integer given");
        }
    };

    // upsellCloses.forEach((closeButton) => {
    //     closeButton.addEventListener('click', () => {
    //         closeCartUpsellSection();
    //         sessionStorage.setItem('cartUpsellClosed', 'true');
    //     });
    // });

    // upsellAtcs.forEach((upsellAtc) => {
    //     upsellAtc.addEventListener('click', () => {
    //         setTimeout(() => {
    //             cartUpsellSwiper.removeSlide(cartUpsellSwiper.activeIndex);
    //         }, 1000);
    //         setTimeout(() => {
    //             if (cartUpsellSwiper.slides.length < 1) {
    //                 closeCartUpsellSection();
    //             }
    //         }, 1200);
    //     });
    // });

    // ip based cart
    fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(json => {
            let threshold = 0;
            const currentCountry = json.detected_values.country.handle;

            switch (currentCountry) {
                case 'DE':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdDe);
                    break;

                case 'AT':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdAt);
                    break;

                case 'CH':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdCh);
                    break;

                case 'LU':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdCh);
                    break;

                case 'LI':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdCh);
                    break;

                case 'NL':
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdNl);
                    break;

                default:
                    threshold = parseFloat(cartCheeringbar.dataset.thresholdCh);
            }

            const widthPerEuro = 100 / threshold;

            document.addEventListener('rerenderCart', () => {
                fetch("/cart.json").then(response => response.json()).then(cart => {
                    let totalPrice = cart.total_price / 100;
                    let pfandPrice = 0;

                    cart.items.forEach((cartItem) => {
                        if (cartItem.product_id == pfandId) {
                            pfandPrice += cartItem.final_line_price;
                        }
                    });

                    // convert to money
                    pfandPrice /= 100;

                    if (currentCountry != 'DE') {
                        totalPrice -= pfandPrice;
                    }

                    const value = totalPrice * widthPerEuro;
                    updateCartDrawerHeight();

                    if (totalPrice > 0 && totalPrice < threshold) {
                        // if (sessionStorage.getItem('cartUpsellClosed') !== 'true') {
                        //     openCartUpsellSection();
                        // }
                        remainingPriceEl.textContent = (threshold - totalPrice).toFixed(2);
                        cheeringbarFill.style.width = value + '%';
                        cartCheeringbar.dataset.level = '1';
                    } else if (totalPrice >= threshold) {
                        // if (sessionStorage.getItem('cartUpsellClosed') !== 'true') {
                        //     openCartUpsellSection();
                        // }
                        cheeringbarFill.style.width = '100%';
                        cartCheeringbar.dataset.level = '2';
                    } else if (totalPrice <= 0) {
                        remainingPriceEl.textContent = (threshold - totalPrice).toFixed(2);
                        cheeringbarFill.style.width = value + '%';
                        cartCheeringbar.dataset.level = '0';
                        // closeCartUpsellSection();
                    }

                    setTimeout(() => {
                        const cartShippingNotice = cartDrawer.querySelector('.ProductMeta__TaxNotice');

                        if (cartShippingNotice) {
                            if (totalPrice >= threshold) {
                                cartShippingNotice.dataset.freeShipping = 'true';
                            } else {
                                cartShippingNotice.dataset.freeShipping = 'false';
                            }
                        }
                    }, 500);

                    // watch vegane bowls
                    // iterate over cart items and look if they are contained in Vegane Bowls
                    let collectionItemsInCartCount = 0;

                    setTimeout(() => {
                        const cartItems = cartDrawer.querySelectorAll('.CartItemWrapper');

                        cartItems.forEach((cartItem) => {
                            if (cartItem.dataset.collections.includes('Vegane Bowls')) {
                                const selectedQuanitityOfWantedItem = parseInt(cartItem.querySelector('.QuantitySelector__CurrentQuantity').value);
                                collectionItemsInCartCount += selectedQuanitityOfWantedItem;
                            }
                        });
                        updateProductCheeringBar(collectionItemsInCartCount);

                        // update upsell section
                        // updateUpsellSwiperProducts();
                    }, 1000);
                });
            });
        });
})();
